import { render } from "./enterprise_transunion_kyb_form.html?vue&type=template&id=20d30278&external"
import script from "./enterprise_transunion_kyb_form.js?vue&type=script&lang=js&external"
export * from "./enterprise_transunion_kyb_form.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__